import '@wix/design-system/styles-default.global.css';
import { eclipseServerData } from '@wix/package-picker-shared-eclipse';
import React from 'react';
import ReactDOM from 'react-dom';
import { EclipseApplication } from './exported-components/eclipse-app';
import { addToDebugData, getSearchParams } from '@wix/package-picker-shared';

const { basename, userId, locale, clientId, siteAuthorizationType } =
  eclipseServerData.get();
addToDebugData({
  eclipseServerData: eclipseServerData.get(),
});
const { siteGuid } = getSearchParams();

ReactDOM.render(
  <EclipseApplication
    basename={basename}
    userId={userId}
    siteGuid={siteGuid ?? ''}
    locale={locale ?? 'en'}
    clientId={clientId}
    siteAuthorizationType={siteAuthorizationType}
  />,
  document.getElementById('root'),
);
